import { render, staticRenderFns } from "./DictionariesPicture.vue?vue&type=template&id=78a9f518&scoped=true&"
import script from "./DictionariesPicture.vue?vue&type=script&lang=js&"
export * from "./DictionariesPicture.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesPicture.vue?vue&type=style&index=0&id=78a9f518&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a9f518",
  null
  
)

export default component.exports